<script>
    import { MDBBtn, MDBContainer, MDBIcon } from "mdbsvelte";
</script>

<main>
    <div class="footerWrapper">
        <div class="spacer" />
        <div class="footerGrid">
            <div class="column">
                <div class="logoBar">
                    <img
                        src="/assets/images/logo.jpg"
                        alt="logo"
                        height="100%"
                        width="100%"
                    />
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">CONTACT</div>

                <div class="footerContent">
                    Help & Support
                    <br /> Payment Options
                    <br /> (855) 487-0740
                    <br />
                    help@minibardelivery.com
                    <br /> (917) 633-6332
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">QUICK LINKS</div>
                <div class="footerContent">
                    <div class="">Privacy Policy</div>
                    <div class="">Shiiping & Delivery</div>
                    <div class="">Terms & Conditions</div>
                    <div class="">About Us</div>
                    <div class="">Contact Us</div>
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">CONNECT</div>
                <div class="footerContent" style="font-size: 25px;">
                    <MDBIcon style="color:#4267B2;" fab icon="facebook" />
                    <MDBIcon style="color:#1DA1F2;" fab icon="twitter" />
                    <MDBIcon style="color:#E1306C;" fab icon="instagram" />
                    <MDBIcon style="color:#F4B400;" fas icon="map-marked" />
                    <MDBIcon style="color:#4267B2;" fab icon="linkedin" />
                    <MDBIcon style="color:#DB4437;" fas icon="mail-bulk" />
                </div>
            </div>
        </div>

        <div class="spacer" />
        <div class="footerTitle">CATEGORIES</div>
        <div class="footerGrid">
            <div class="column">
                <div class="footerTitle">LIQUORS</div>
                <div class="footerContent">
                    <div class="">Vodka</div>
                    <div class="">Gin</div>
                    <div class="">Whiskey</div>
                    <div class="">Scotch</div>
                    <div class="">Tequila</div>
                    <div class="">Rum</div>
                    <div class="">Brandy</div>
                    <div class="">Cognac</div>
                    <div class="">SHOP ALL LIQUORS</div>
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">WINE</div>
                <div class="footerContent">
                    <div class="">White</div>
                    <div class="">Red</div>
                    <div class="">Rose</div>
                    <div class="">Champagne</div>
                    <div class="">Dessert</div>
                    <div class="">Fortified</div>
                    <div class="">Mead</div>
                    <div class="">Spritzer</div>
                    <div class="">SHOP ALL WINES</div>
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">BEER</div>
                <div class="footerContent">
                    <div class="">Cider</div>
                    <div class="">Lager</div>
                    <div class="">Keg</div>
                    <div class="">Non Alcoholic</div>
                    <div class="">SHOP ALL BEERS</div>
                </div>
            </div>
            <div class="column">
                <div class="footerTitle">MIXERS</div>
                <div class="footerContent">
                    <div class="">Juice</div>
                    <div class="">Dairy</div>
                    <div class="">Soda</div>
                    <div class="">Energy</div>
                    <div class="">Sports</div>
                    <div class="">Slurpee</div>
                    <div class="">SHOP ALL MIXERS</div>
                </div>
            </div>
        </div>

        <div class="spacer" />

        <div class="copy" style="font-size: 12px;">
            <div class="footerGrid">
                <div class="column">
                    All Rights Reserved. 2021 | www.cityliquor.co.ke
                </div>
                <div class="column" style="text-align: right;">
                    Site By <a
                        href="vilwave.com"
                        style="color: brown;font-style:italic;"
                        >Vilwave Technologies</a
                    >
                </div>
            </div>
        </div>
    </div>
</main>

<style>
    main {
        background: rgb(233, 238, 237);
        text-align: left;
    }

    .footerWrapper {
        max-width: 80em;
        margin: auto;
        padding-left: 2em;
    }

    .footerGrid {
        display: flex;
        flex-direction: column;
    }

    .column {
        flex: 1;
        padding: 1em;
    }

    .spacer {
        height: 1em;
    }

    .logoBar {
        width: 8em;
        height: 8em;
        /* background: yellow; */
        margin: 3em auto;
        border-radius: 50%;
        overflow: hidden;
    }

    .footerTitle {
        font-weight: 700;
        padding-bottom: 1em;
        color: rgb(107,107,107);
    }
    .footerContent {
        font-size: 13px;
        font-weight: 100;
        line-height: 24px;
        color: rgb(107, 107, 107);
    }

    @media only screen and (min-width: 600px) {
        .footerWrapper {
            max-width: 80em;
            margin: auto;
            padding-left: 0;
        }

        .footerGrid {
            display: flex;
            flex-direction: row;
        }

        .column {
            flex: 1;
        }
    }
</style>
